import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Minus } from 'lucide-react';
import { Icon, Check } from '@/components/atoms/Icon';
import { cn } from '@/utils/cn';
import type { CheckboxProps } from './Checkbox.types';
import styles from './Checkbox.module.scss';

export function Checkbox({
  label,
  checked,
  defaultChecked,
  onCheckedChange,
  disabled = false,
  required = false,
  name,
  value,
  className,
  id,
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledBy,
}: CheckboxProps) {
  const checkboxClasses = cn(
    styles.checkbox,
    disabled && styles['checkbox--disabled'],
    className
  );

  return (
    <div className={checkboxClasses}>
      <CheckboxPrimitive.Root
        className={styles.checkbox__input}
        checked={checked}
        defaultChecked={defaultChecked}
        onCheckedChange={(next) => onCheckedChange?.(next === true)}
        disabled={disabled}
        required={required}
        name={name}
        value={value}
        id={id}
        aria-label={ariaLabel}
        aria-labelledby={ariaLabelledBy}
      >
        <CheckboxPrimitive.Indicator className={styles.checkbox__indicator}>
          {/* Parcial: guion en vez de check, como en cualquier tabla con selección. */}
          <Icon icon={checked === 'indeterminate' ? Minus : Check} size="sm" />
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>

      {label && (
        <label htmlFor={id} className={styles.checkbox__label}>
          {label}
          {required && (
            <span className={styles.checkbox__required} aria-label="required">
              *
            </span>
          )}
        </label>
      )}
    </div>
  );
}

export default Checkbox;
